import type { ReactNode } from "react";

interface StepShellProps {
  number: number;
  title: string;
  active: boolean;
  children: ReactNode;
}

export function StepShell({ number, title, active, children }: StepShellProps) {
  return (
    <section className="step">
      <div className="step__head">
        <span className={active ? "step__num" : "step__num step__num--idle"} aria-hidden="true">
          {number}
        </span>
        <h3>{title}</h3>
      </div>
      <div className="stack stack-4" style={{ marginTop: "var(--gap-4)" }}>
        {children}
      </div>
    </section>
  );
}
